import useMessagingPage from '../../../../hooks/useMessagingPage';
import MessageCard from '../../messageCard';
import './index.css';

interface ChatProps {
  id: string;
  hideHeader?: boolean;
}

const WatchChatPage = (props: ChatProps) => {
  const { id } = props;
  const { messages, newMessage, setNewMessage, handleSendMessage, error } = useMessagingPage(
    'watch',
    id,
  );

  return (
    <div className='chat-room'>
      <div className='chat-messages'>
        {messages.map(message => (
          <MessageCard key={String(message._id)} message={message} />
        ))}
      </div>
      <div className='message-input'>
        <textarea
          className='message-textbox'
          placeholder='Type your message here'
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
        />
        <div className='message-actions'>
          <button className='send-button' onClick={handleSendMessage}>
            Send
          </button>
          {error && <span className='error-message'>{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default WatchChatPage;
